const firebaseConfig = {
  apiKey: "AIzaSyBAAfmpaQwcnhiJS1BPeYVALaEYlGFgl8s",
  authDomain: "e-stationarybd.firebaseapp.com",
  projectId: "e-stationarybd",
  storageBucket: "e-stationarybd.appspot.com",
  messagingSenderId: "46338625043",
  appId: "1:46338625043:web:7a7c03bb8e311d2fd2f9e6"
};

  export default firebaseConfig;